export class BaseCriteria {

    constructor() {
        this.PageSize=15;
    }
    PagingEnabled?:boolean;
    PageSize?:number;
    PageNumber?:number;
    FreeText?:string;
}